import { render, staticRenderFns } from "./PlanosPagamento.vue?vue&type=template&id=49f477ce"
import script from "./PlanosPagamento.vue?vue&type=script&lang=js"
export * from "./PlanosPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports